import {clsx, type ClassValue} from 'clsx';
import {extendTailwindMerge} from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Register text-label-* as font-size classes so they don't conflict with text colors
      'font-size': [{text: ['label-sm', 'label-md', 'label-lg', 'header-sm', 'header-md', 'header-lg']}],
    },
  },
});

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}
